import React from "react";
import { Box, FormControl, InputLabel, Select, MenuItem, Button } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format, parseISO } from "date-fns";

const reportingTitle = {
  "1": "Daily",
  "2": "Weekly",
  "3": "Monthly",
  "4": "Custom"
};

function PayrollReportFilters({
  duration,
  setDuration,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onRunReport
}) {
  const handleDurationChange = (e) => {
    setDuration(e.target.value);
    if (e.target.value !== "4") {
      // Auto-set dates based on duration if needed (can expand later)
      onRunReport();
    }
  };

  const handleStartDateChange = (date) => {
    if (date) {
      setStartDate(format(date, "yyyy-MM-dd"));
    }
  };

  const handleEndDateChange = (date) => {
    if (date) {
      setEndDate(format(date, "yyyy-MM-dd"));
    }
  };

  return (
    <Box sx={{ backgroundColor: "#FFFFFF", padding: "20px", borderRadius: "8px", mb: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap" }}>
        {/* Duration Selector */}
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Select View</InputLabel>
          <Select
            value={duration}
            label="Select View"
            onChange={handleDurationChange}
            sx={{
              height: "40px",
              borderRadius: "5px",
              background: "white"
            }}
          >
            <MenuItem value="1">Daily</MenuItem>
            <MenuItem value="2">Weekly</MenuItem>
            <MenuItem value="3">Monthly</MenuItem>
            <MenuItem value="4">Custom Date Range</MenuItem>
          </Select>
        </FormControl>

        {/* Start Date - Only show in Custom */}
        {duration === "4" && (
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="From Date"
              value={startDate ? parseISO(startDate) : null}
              onChange={handleStartDateChange}
              format="yyyy-MM-dd"
              slotProps={{ textField: { sx: { width: 180 } } }}
            />
          </LocalizationProvider>
        )}

        {/* End Date - Only show in Custom */}
        {duration === "4" && (
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="To Date"
              value={endDate ? parseISO(endDate) : null}
              onChange={handleEndDateChange}
              format="yyyy-MM-dd"
              slotProps={{ textField: { sx: { width: 180 } } }}
            />
          </LocalizationProvider>
        )}

        {/* Run Report Button */}
        <Button
          variant="contained"
          onClick={onRunReport}
          sx={{
            height: "40px",
            backgroundColor: "#5523D2",
            "&:hover": { backgroundColor: "#4419a8" },
            px: 4
          }}
        >
          Run Report
        </Button>
      </Box>
    </Box>
  );
}

export default PayrollReportFilters;